// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3Z4pI","visuallyhidden":"IQBmf","hide-text":"_3oLXN","center":"_1iJuE","noprint":"YxJDa","root":"_1zGG4"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/styles/Svg.scss
 ** module id = 955
 ** module chunks = 1
 **/